export default "__VITE_ASSET__ecca5c1a__"